import { Typography } from "antd";
import React from "react";
import LinkToGoogleCalendar from "./LinkToGoogleCalendar";
import { UserProvider } from "../../../Entities/UserProvider";

interface InterviewSettingsPageHeaderProps {
  handleGoogleSignIn: (success: boolean) => void;
  userProviders: UserProvider | null;
}

const InterviewSettingsPageHeader: React.FC<
  InterviewSettingsPageHeaderProps
> = ({ handleGoogleSignIn, userProviders }) => {
  return (
    <div className="interview-settings-page-header">
      <Typography.Title level={4} style={{ margin: 0 }} ellipsis>
        Interview Settings
      </Typography.Title>
      <section>
        <LinkToGoogleCalendar
          onGoogleSignIn={handleGoogleSignIn}
          userProviders={userProviders}
        />
      </section>
    </div>
  );
};

export default InterviewSettingsPageHeader;
